export default "__VITE_ASSET__BHGZ8NZX__"